import {Field} from 'formik';

import {
    Container,
    Stack,
} from '@mantine/core';
import {
    FormikNumberInput,
    FormikRadioCardGroup,
    FormikTextarea,
    PlatformFieldset
} from "@flexinet/ui-components";
import {
    BillingPeriod,
    Price,
    PriceStatus,
    PricingModel,
    RecurringOption
} from "../types.ts";
import {RatePlansAutocomplete} from "../../rate-plans/inputs/RatePlansAutocomplete.tsx";


export const FormComponent = ({values}: { values: Price }) => {

    console.log('values', values)

    return (
        <Container>
            <Stack>

                <PlatformFieldset legend={'Billing Type'}>

                    <Field
                        name='recurringOption'
                        label='Recurring'
                        description='Please enter the billing type'
                        data={[{
                            label: 'Recurring',
                            value: RecurringOption.Yes
                        }, {
                            label: 'One-off',
                            value: RecurringOption.No
                        }]}
                        component={FormikRadioCardGroup}
                        withAsterisk
                        my={'xl'}
                    />


                </PlatformFieldset>

                <PlatformFieldset legend={'Pricing Model'}>

                    <Field
                        name='pricingModel'
                        label='Pricing Model'
                        description='Please enter the billing scheme'
                        data={[{
                            label: 'Flat Rate',
                            value: PricingModel.FlatRate
                        }, {
                            label: 'Package Based',
                            value: PricingModel.PackageBased
                        }, {
                            label: 'Volume Based',
                            value: PricingModel.VolumeBased
                        }, {
                            label: 'Usage Based',
                            value: PricingModel.UsageBased
                        }]}
                        component={FormikRadioCardGroup}
                        withAsterisk
                        my={'xl'}
                    />


                </PlatformFieldset>

                {values.pricingModel === 'FlatRate' ? <PlatformFieldset legend={'Price'}>

                    <Field
                        name='amount'
                        label='Amount'
                        description='Please enter the amount'
                        component={FormikNumberInput}
                        withAsterisk
                        my={'xl'}
                    />
                </PlatformFieldset> : null}

                {values.pricingModel === 'UsageBased' ? <PlatformFieldset legend={'Pricing Model'}>

                    <Field
                        name='ratePlanId'
                        label='Rate Plan'
                        description='Please enter the rate plan'
                        component={RatePlansAutocomplete}
                        withAsterisk
                        my={'xl'}
                    />
                </PlatformFieldset> : null}


                {values.recurringOption === RecurringOption.Yes ? <PlatformFieldset legend={'Billing Period'}>

                    <Field
                        name='billingPeriod'
                        label='Billing Period'
                        description='Please enter billing period'
                        component={FormikRadioCardGroup}
                        data={
                            [
                                {
                                    value: BillingPeriod.Monthly,
                                    label: BillingPeriod.Monthly,
                                },
                                {
                                    value: BillingPeriod.Weekly,
                                    label: BillingPeriod.Weekly,
                                },
                                {
                                    value: BillingPeriod.Annually,
                                    label: BillingPeriod.Annually,
                                },
                                {
                                    value: BillingPeriod.Daily,
                                    label: BillingPeriod.Daily,
                                },
                                {
                                    value: BillingPeriod.Custom,
                                    label: BillingPeriod.Custom,
                                }
                            ]
                        }
                        my={'xl'}
                    />

                </PlatformFieldset> : null}

                <PlatformFieldset legend={'Description'}>

                    <Field
                        name='description'
                        label='Description'
                        description='Please enter description'
                        component={FormikTextarea}
                        my={'xl'}
                    />

                </PlatformFieldset>

                <PlatformFieldset legend={'Status'}>

                    <Field
                        name='priceStatus'
                        label='Status'
                        description='Please enter status'
                        component={FormikRadioCardGroup}
                        data={
                            [
                                {
                                    value: PriceStatus.Active,
                                    label: PriceStatus.Active,
                                },
                                {
                                    value: PriceStatus.Inactive,
                                    label: PriceStatus.Inactive,
                                }
                            ]
                        }
                        withAsterisk
                        my={'xl'}
                    />

                </PlatformFieldset>


            </Stack>
        </Container>
    );
};

